
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import { ErrorObject } from '@vuelidate/core'

export default defineComponent({
  props: {
    errors: {
      type: Array as PropType<ErrorObject[]>,
      default: () => []
    }
  }
})
